module.exports = __webpack_public_path__ + "static/media/product-hunt.95bff6e5.png";